import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Reveal } from "@/components/Motion";

export const AboutTeaser = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["30px", "-50px"]);

  return (
    <section ref={ref} data-testid="about-section" className="mx-auto max-w-[1440px] px-5 md:px-10 py-24 md:py-40 grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
      <div className="lg:col-span-5 relative pr-8 pb-8">
        <motion.div style={{ y: y2 }} className="absolute right-0 bottom-0 w-3/4 h-3/4 bg-blush" />
        <Reveal className="relative h-[460px] sm:h-[600px] overflow-hidden">
          <motion.img style={{ y }} src="/img/flavor-brown-butter-chocolate-chip.jpg" alt="Brown Butter Chocolate Chip cookie" className="absolute inset-0 w-full h-[116%] -top-[8%] object-cover bg-[#F1EDE4]" />
        </Reveal>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        <p className="eyebrow mb-6">About the Studio</p>
        <MaskLines lines={["Made for the", <span className="italic text-mocha">moments you</span>, "linger over."]} className="font-display font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.95]" />
        <Reveal delay={0.1} className="mt-10 space-y-5 text-mocha leading-relaxed max-w-xl text-base md:text-lg">
          <p>Lise’s Sugar Studio began with a simple love for creating something sweet and making people feel special.</p>
          <p>It’s about the little moments surrounding dessert — the excitement when a box is opened, the first bite, the dessert everyone talks about after the celebration is over.</p>
        </Reveal>
        <Reveal delay={0.2} className="mt-10 flex items-center gap-8">
          <span className="font-display italic text-4xl text-cocoa">— Lise</span>
          <Link to="/about" data-testid="about-read-more" className="link-u text-[12px] uppercase tracking-[0.24em] pb-1">Read our story</Link>
        </Reveal>
      </div>
    </section>
  );
};
